(function() {
  function initFooterNewsletter() {
    var selector = "#ometria_form_landing_page_01";
    var form = document.querySelectorAll(selector)[0];

    if (!form) {
      return;
    }

    // DMR tracking: one opaque local attempt ID; no form answers are read.
    if (form.__dmrNewsletterBound) return;
    form.__dmrNewsletterBound = true;
    var trackingAttempt = null;

function startTrackingAttempt() {
  if (trackingAttempt) return;

  trackingAttempt = window.crypto && window.crypto.randomUUID ?
    window.crypto.randomUUID() :
    String(Date.now()) + '-' + Math.random().toString(36).slice(2);
}

// Capture the Subscribe button before Ometria handles it.
form.addEventListener('click', function(event) {
  var button = event.target.closest(
    'button, input[type="submit"], input[type="image"]'
  );

  if (button && button.form === form &&
      (button.type === 'submit' || button.type === 'image')) {
    startTrackingAttempt();
  }
}, true);

// Capture keyboard submission.
form.addEventListener('keydown', function(event) {
  if (event.key === 'Enter' &&
      event.target.tagName === 'INPUT' &&
      !event.isComposing) {
    startTrackingAttempt();
  }
}, true);

form.addEventListener('submit', startTrackingAttempt, true);

    // Ometria callback function to handle form submission response
    function ometriaCallback(response) {
      var successMessage = document.querySelector('.footer_subscription_success');

      if (response && response.ok === true) {
        if (trackingAttempt) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'dmr_newsletter_success',
            dmr_form_provider: 'ometria',
            dmr_form_type: 'newsletter',
            dmr_form_context: 'footer',
            dmr_submission_id: 'ometria-footer-' + trackingAttempt,
            dmr_page_path: window.location.pathname
          });
          trackingAttempt = null;
        }
        // Success: show success message and reset form
        if (successMessage) {
          successMessage.classList.remove('hidden');
        }
        form.reset();
      } else {
        trackingAttempt = null;
        if (response && response.errors && response.errors.length > 0) {
          // Do not log vendor responses or customer answers.
          // Hide success message if it was shown
          if (successMessage) {
            successMessage.classList.add('hidden');
          }
          // Add error handling message here
        }
      }
    }

    // Wait for Ometria script to be loaded before initializing AJAX form
    var ometriaAjaxInitialized = false;

    function initOmetriaAjax() {
      if (ometriaAjaxInitialized) return true;
      if (typeof ometria !== 'undefined' && typeof ometria.ajaxFormSubmit === 'function') {
        ometria.ajaxFormSubmit(selector, ometriaCallback);
        ometriaAjaxInitialized = true;
        return true;
      }
      return false;
    }

    // Retry function to wait for Ometria
    function waitForOmetria() {
      if (!initOmetriaAjax()) {
        if (typeof waitForOmetria.retryCount === 'undefined') {
          waitForOmetria.retryCount = 0;
        }
        if (waitForOmetria.retryCount < 50) { // Retry up to 5 seconds (50 * 100ms)
          waitForOmetria.retryCount++;
          setTimeout(waitForOmetria, 100);
        } else {
          console.warn('Ometria script not loaded after retries. Form will submit normally.');
        }
      }
    }

    // Prevent default form submission once Ometria AJAX is initialized
    // This ensures the form doesn't reload the page
    form.addEventListener('submit', function(event) {
      if (ometriaAjaxInitialized) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      // If Ometria isn't ready yet, check one more time
      if (typeof ometria !== 'undefined' && typeof ometria.ajaxFormSubmit === 'function') {
        if (!ometriaAjaxInitialized) {
          initOmetriaAjax();
        }
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    }, false);

    // Start initialization immediately
    waitForOmetria();

    // Also try on window load (for scripts with defer attribute)
    window.addEventListener('load', function() {
      if (!ometriaAjaxInitialized) {
        waitForOmetria();
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterNewsletter);
  } else {
    initFooterNewsletter();
  }
})();
